import styled from 'styled-components';
import Link from '@mlb/react-patterns/components/Link/link';
import COLORS from '@mlb/react-patterns/style/universal.color';
import { InnerWrapper, LeftButton, RightButton, OuterWrapper } from '@mlb/react-patterns/components/ControlledOverflow/controlledOverflow.style';
import Button from '@mlb/react-patterns/components/Button/button';

const {
    mlbBlack,
    mlbWhite
} = COLORS;

export const VideoCarouselWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    ${OuterWrapper} {
        ${LeftButton},
        ${RightButton} {
            height: 40px;
            width: 40px;
            background-color: var(--gameday-video-carousel-button-color);
            &:hover {
                background-color: var(--gameday-video-carousel-button-color-hover);
            }
        }
    }

    ${InnerWrapper} {
        padding-left: 10px;
        scroll-padding-left: 20px;
        overflow-y: hidden;

        & > :first-child {
            scroll-padding-left: 10px;
            scroll-snap-align: start;
        }
        & > :last-child {
            scroll-padding-right: 10px;
            scroll-snap-align: end;

        }

        > div {
            margin: 4px 8px;
        }
    }
`;

export const SkeletonWrapper = styled.div`
    width: 362px;
    height: var(--gameday-video-carousel-height);
    margin: 4px 6px;
`;

export const StorySkeletonWrapper = styled(SkeletonWrapper)`
    width: 121px;
`;

export const LinkSkeletonWrapper = styled(SkeletonWrapper)`
    width: 121px;
`;

export const HighlightWrapper = styled(Link)`
    display: inline-block;
    scroll-snap-align: center;
    flex-shrink: 0;
    flex-negative: 0;
    margin: 4px 8px;
    width: 362px;
    height: var(--gameday-video-carousel-height);
    border-radius: 7px;
    background-image: ${({ backgroundImage }) => backgroundImage ? `url("${backgroundImage}")` : 'none'};
    background-position: center;
    background-color: ${mlbBlack};
    background-size: cover;
    position: relative;
    cursor: pointer;
    box-shadow: 0 0 4px 0 var(--gameday-video-carousel-shadow-color);
`;

export const CarouselItemHeader = styled.div`
    position: absolute;
    font-weight: bold;
    font-size: 18px;
    color: #fff;
    line-height: 18px;
    height: auto;
`;

export const StoryWrapper = styled(Link)`
    position: relative;
    width: var(--gameday-gamestory-height);
    background-color: transparant;
    border-radius: 7px;
    margin: 4px 8px;
    height: var(--gameday-video-carousel-height);
    box-shadow: 0 0 4px 0 var(--gameday-video-carousel-shadow-color);
    cursor: pointer;
    flex-shrink: 0;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
`;

export const StoryInfo = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 121px;
    height: 100%;
    flex-grow: 0;
    border-radius: 7px;
    background-image: var(--gameday-game-story-gradient);
    display: flex;
`;

export const StoryText = styled.div`
    display: flex;
    line-height: 20px;
    font-size: 18px;
    font-weight: bold;
    color: ${mlbWhite};
    align-items: flex-end;
    padding: 0 0 8px 8px;
`;

export const FilmRoomLinkWrapper = styled(Link)`
    display: flex;
    align-items: center;
    width: 105px;
    border-radius: 7px;
    margin: 4px 8px;
    padding: 0 8px;
    background-color: var(--gameday-video-carousel-more-background);
    box-shadow: 0 0 4px 0 var(--gameday-video-carousel-shadow-color);
    height: var(--gameday-video-carousel-height);
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    flex-shrink: 0;
    margin-right: 0px;
    color: var(--gameday-primary-font-color) !important;
    line-height: 21px;
    &:hover {
        color: var(--gameday-link-color) !important;
    }
`;

export const LoadingWrapper = styled.div`
    display: inline-flex;
    margin-left: var(--gameday-section-padding-sm);
`;

export const TitleWrapper = styled.div`
    font-size: 24px;
    font-weight: 700;
    line-height: 24px;
    margin-left: var(--gameday-section-padding-sm);
`;

export const SeeAllButton = styled(Button)`
    font-weight: 500;
    padding-left: 0;
    padding-right: 16px;
    border-radius: 0;
    height: 16px;
    margin-top: 6px;
    font-size: 16px;
    line-height: 16px;
    color: var(--gameday-wrap-seeall-color);
`;

export const HeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    font-family: var(--gameday-primary-font);
    margin-bottom: 12px;
`;
